// extracted by mini-css-extract-plugin
module.exports = {"root":"GamDisplaySlot_root__MzCTh","slot":"GamDisplaySlot_slot__pVtF0","devLabel":"GamDisplaySlot_devLabel__m__cM"};